import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  sliderSection: {
    marginBottom: theme.spacing(2),
    background: theme.palette.background.paper,
    height: '100%',
    borderRadius: theme.shape.borderRadius,

    '& section': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80%',
    },

    '& article': {
      height: '88%',

      '& div': {
        height: '100%',

        '& .css-1abc02a, & .css-hn784z': {
          top: '-3rem',
        },
      },

      '& article': {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',

        '& div': {
          height: 'initial',
          marginBottom: theme.spacing(1),

          '&:last-child': {
            alignSelf: 'flex-end',
          },
        },
      },
    },
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  icon: {
    marginRight: theme.spacing(2),
  },

  description: {
    marginBottom: theme.spacing(2),
    position: 'relative',
    overflow: 'hidden',
  },

  overflow: {
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '1.5rem',
      background: `linear-gradient(to top, ${theme.palette.background.paper}, transparent)`,
      display: 'block',
    },
  },
}));

export default useStyles;
